<template>
    <div>
        <v-container fluid :style="{ 'min-height': '800px' }">
            <v-container class="contain-width">
                <v-row>
                    <v-col
                            cols="12"
                            md="7"
                            offset-md="1"
                    >
                        <v-row
                            v-for="(product,index) in basketProducts"
                            :key="index"
                            class="basket-item"
                        >
                            <v-col
                                cols="12"
                                md="7"
                                sm="12"
                            >
                                <v-card
                                    elevation="0"
                                >
                                    <div class="d-flex flex-no-wrap">

                                        <router-link
                                                :to="{ name: 'product', params: {slug: product.slug} }"
                                        >
                                            <v-img
                                                    v-if="product.image"
                                                    :src="require('@/assets/' + product.image)"
                                                    aspect-ratio="1.6"
                                                    class="primary"
                                                    min-width="160"
                                                    min-height="80"
                                            ></v-img>
                                        </router-link>

                                        <div class="basket-detail">
                                            <v-card-title
                                                    class="headline primary--text"
                                            >
                                                <router-link
                                                        :to="{ name: 'product', params: {slug: product.slug} }"
                                                >{{ product.name }}</router-link>
                                            </v-card-title>

                                            <p class="title">{{ brand === 'neotag' ? '€' : '£'}}{{ product.price }}</p>

                                            <v-switch
                                                    class="ml-4"
                                                    v-if="brand !== 'neotag' && product.claimable"
                                                    v-model="personalised"
                                                    inset
                                                    :label="personalised ? $t('labels.Switch to non personalised') : $t('Switch to personalised')"
                                            ></v-switch>

                                        </div>
                                    </div>
                                </v-card>
                            </v-col>
                            <v-col
                                md="5"
                                sm="12"
                            >
                                <ValidationObserver ref="observer">
                                    <v-form v-model="valid" @submit.prevent="handleSubmit">
                                        <ValidationProvider vid="assign" :name="$t('labels.Assign tag')" rules="required" v-slot="{ errors }" v-if="product.personalisable === true">
                                            <v-select
                                                    :items="personalise"
                                                    item-text="name"
                                                    item-value="id"
                                                    v-model="basketProducts[index].dependant"
                                                    :error-messages="errors[0]"
                                                    no-data-text="Personalise with name"
                                                    :label="$t('labels.Assign tag')"
                                                    :hint="$t('hints.Select who the tags are for')"
                                                    persistent-hint
                                                    required
                                                    @change="onChange($event, index)"
                                                    @clear="onClear()"
                                                    clearable
                                            ></v-select>
                                        </ValidationProvider>

                                        <ValidationProvider vid="quantity" :name="$t('labels.Quantity')" rules="required" v-if="!product.claimable && product.personalisable !== true">
                                            <span
                                                    class="display-1 font-weight-light"
                                                    v-text="basketProducts[index].quantity"
                                            ></span>
                                            <v-slider
                                                    v-model="basketProducts[index].quantity"
                                                    color="primary"
                                                    :label="$t('labels.Quantity')"
                                                    :hint="$t('hints.Number required')"
                                                    min="1"
                                                    max="100"
                                                    thumb-label
                                            >
                                                <template v-slot:prepend>
                                                    <v-icon
                                                            color="primary"
                                                            @click="decrement(index)"
                                                    >
                                                        mdi-minus
                                                    </v-icon>
                                                </template>

                                                <template v-slot:append>
                                                    <v-icon
                                                            color="primary"
                                                            @click="increment(index)"
                                                    >
                                                        mdi-plus
                                                    </v-icon>
                                                </template>
                                            </v-slider>
                                        </ValidationProvider>
                                    </v-form>
                                </ValidationObserver>
                                <v-btn
                                    v-if="!product.claimable"
                                    icon
                                    @click="removeFromBasket(index)"
                                    class="float-right"
                                >
                                    <v-icon
                                            large
                                            color="grey lighten-1"
                                    >delete</v-icon>
                                </v-btn>
                                <p class="mt-6" v-if="basketProducts[index].cashback"><v-icon color="green">check</v-icon>{{ $t('Cashback applied for {organisation}', {organisation:  basketProducts[index].cashback.organisation}) }}</p>
<!--                                <p class="mt-6" v-if="basketProducts[index].cashback"><v-icon color="green">check</v-icon> Cashback code {{ basketProducts[index].cashback.code }} applied for {{ basketProducts[index].cashback.organisation }}</p>-->
<!--                                <p class="mt-6" v-if="basketProducts[index].dependant && cashbacksConfirmed(basketProducts[index].dependant.id) && cashbacksConfirmed(basketProducts[index].dependant.id).dependant.id === basketProducts[index].dependant.id"><v-icon color="green">check</v-icon> Cashback code {{cashbacksConfirmed(basketProducts[index].dependant.id).dependant.code}} applied for {{cashbacksConfirmed(basketProducts[index].dependant.id).organisation}}.</p>-->
                            </v-col>
                        </v-row>

                        <v-row class="basket-item" v-if="onlyClaimable">
                            <v-col
                                    cols="12"
                            >
                                <p class="ml-4 mt-4 font-weight-bold text-subtitle-1">{{ $t('Need more labels?') }} <router-link
                                        :to="{ name: 'products' }"
                                >{{ $t('links.take me to the shop') }}</router-link></p>
                            </v-col>
                        </v-row>

<!--                        <v-btn-->
<!--                                rounded-->
<!--                                block-->
<!--                                color="secondary"-->
<!--                                elevation="0"-->
<!--                                @click="clearBasket(index)"-->
<!--                                class="clear-button float-left"-->
<!--                        >-->
<!--                            <v-icon-->
<!--                                    large-->
<!--                                    color="white"-->
<!--                            >remove_shopping_cart</v-icon> Clear basket-->
<!--                        </v-btn>-->
                    </v-col>
                    <v-col
                            md="3"
                    >
                        <v-card
                                v-if="basketProducts.length > 0"
                                class="basket-card"
                        >
                            <div class="totals">
                                <div class="d-flex justify-space-between">
                                    <p class="title">{{ $t('Sub-total') }}</p>
                                    <p class="title text-right">{{ brand === 'neotag' ? '€' : '£'}}{{ productsTotal ? productsTotal : '0.00' }}</p>
                                </div>
                                <div class="d-flex justify-space-between" v-if="voucherDiscount > 0">
                                    <p class="title">{{ $t('Voucher applied') }}</p>
                                    <p class="title text-right">-{{ brand === 'neotag' ? '€' : '£'}}{{voucherDiscount}}</p>
                                </div>
                                <div class="d-flex justify-space-between">
                                    <p class="title">{{ $t('Postage') }}</p>
                                    <p class="title text-right">{{ $t('FREE') }}</p>
                                </div>
                                <div class="d-flex justify-space-between">
                                    <p class="title">{{ $t('Total') }}</p>
                                    <p class="title text-right">{{ brand === 'neotag' ? '€' : '£'}}{{ basketTotal ? basketTotal : '0.00' }}</p>
                                </div>
                                <div v-if="voucherAllowed">
                                    <v-form @submit.prevent="handleSubmitVoucher">
                                        <v-text-field
                                                v-model="voucher"
                                                :label="$t('labels.Voucher code')"
                                                prepend-icon="loyalty"
                                                :append-outer-icon="voucher ? 'mdi-chevron-right' : ''"
                                                @click:append-outer="handleSubmitVoucher"
                                        ></v-text-field>
                                    </v-form>
                                </div>
<!--                                <div>-->
<!--                                    Cashback code {{cashbacksConfirmed(basketProducts[index].dependant).code}} applied to products assigned to {{ basketProducts[index].dependant.name }}, for {{cashbacksConfirmed(basketProducts[index].dependant).organisation}}.-->
<!--                                </div>-->
                            </div>

                            <v-card-actions>
                                <v-btn elevation="0" rounded color="primary" class="float-right checkout-button" @click="handleSubmit" v-if="basketProductsCount > 0"><v-icon left>lock</v-icon> {{ $t('buttons.Secure Checkout') }}</v-btn>
                            </v-card-actions>


                        </v-card>

                        <v-dialog v-model="activatesDialog" persistent max-width="600px">
                            <v-card
                                    class="mx-auto form-card"
                                    outlined
                            >

                                <v-card-text class="text--primary">
                                    <p class="body-1 mt-6">{{ $t('Your basket contains {quantity} Activ8 product', {quantity: numActivates}) }}<span v-if="numActivates > 1">s</span> that are non-personalised. By continuing you confirm that you understand that these products will not have a name printed on them, and that the name cannot be added later. These are non-personalised products.</p>
                                </v-card-text>

                                <v-card-actions class="d-flex justify-space-between align-end" style="width: 100%">
                                    <v-btn elevation="0" rounded @click="activatesDialog = false">{{ $t('No, let me change that') }}</v-btn>
                                    <v-btn elevation="0" rounded color="primary" @click="continueCheckout"><v-icon left>lock</v-icon> {{ $t('Yes, continue checkout') }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                    </v-col>
                </v-row>

            </v-container>
        </v-container>
        <Footer />
    </div>
</template>

<script>
    import { store } from '../store';
    import { mapState, mapActions, mapGetters } from 'vuex'
    import { extend } from 'vee-validate';
    import { required } from 'vee-validate/dist/rules';
    import axios from 'axios';


    import Footer from './Footer.vue'
    import {i18n} from "../i18n";

    // Add the required rule
    extend('required', required);

    export default {
        name: "Basket",
        components: {
            'Footer': Footer
        },
        metaInfo () {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('Basket'),
            htmlAttrs: {
              lang: i18n.locale
            },
          }
        },
        data: () => ({
            errorValues: {},
            errorFields: [
                'assign',
            ],
            submitted: false,
            valid: false,
            codeValid: false,
            cashbacks: [],
            cashbackOrganisations: [],
            cashbackOrganisation: null,
            code: '',
            cashbackValid: false,
            voucher: null,
            activatesDialog: false,
            numActivates: 0,
            personalised: false,
            personalisedBundle: null,
            nonPersonalisedBundle: null
        }),
        mounted () {

            window.scrollTo(0,0);


            if (this.claimedProduct && this.claimedProduct.personalisable) {
                console.log(this.claimedProduct)
                this.personalised = true
            }

              const instance = axios.create({
                baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
                headers: {'Accept-Language': i18n.locale}
              });

              instance
                  .get('/api/products/slug/free-bundle-personalised' )
                .then(response => {
                    this.personalisedBundle = response.data.data
                })
                .catch(error => {
                    console.log(error)
                })

              instance
                  .get('/api/products/slug/free-bundle' )
                .then(response => {
                    this.nonPersonalisedBundle = response.data.data
                })
                .catch(error => {
                    console.log(error)
                })
        },
        computed: {
            ...mapState({
                dependants: state => state.account.user.dependants,
                brand: state => state.brand,
                brandName: state => state.brandName
            }),
            ...mapGetters('basket', ['hasCashback', 'products', 'postage', 'voucherAllowed', 'claimedProduct', 'onlyClaimable']),
            getBackground() {
              if (this.brand === 'neotag') {
                return require('@/assets/neotag-background.jpg')
              }
              else {
                return require('@/assets/neotag-background.jpg')
              }
            },
            personalise () {
                return store.getters['account/personalise']
            },
            basketProductsCount () {
                return store.getters['basket/productsCount']
            },
            basketProducts () {
                return this.products
            },
            voucherDiscount () {
                return store.getters['basket/voucherDiscount']
            },
            productsTotal () {
                let productsTotal = store.getters['basket/productsTotal']
                return productsTotal
            },
            basketTotal () {
                let basketTotal = store.getters['basket/basketTotal'] - store.getters['basket/voucherDiscount']
                return basketTotal.toFixed(2)
            },
            myself () {
                return store.getters['account/user']
            }
        },
        methods: {
            ...mapActions('basket', ['remove', 'clear', 'assignDependant', 'addCashback', 'removeCashback', 'applyVoucher', 'addSilent']),
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            removeFromBasket(index) {
                return this.remove({index}).then(() => {
                    //store.dispatch('alert/success', 'Added to basket', { root: true });
                })
            },
            clearBasket() {
                return this.clear().then(() => {
                    //store.dispatch('alert/success', 'Added to basket', { root: true });
                })
            },
            onClear() {
              console.log("clear")
            },
            onChange(event, index) {

                this.cashbackOrganisations = []
                this.cashbackOrganisation = null
                this.cashbacks = []
                this.code = ''



                this.removeCashback({index}).then(() => {
                    console.log(event)
                    if (event) {
                        let dependant = this.dependants.find(item => item.id == event);

                        this.cashbacks = [];

                        if (dependant) {

                            // assign dependant to product
                            this.assignDependant({dependant, index}).then(() => {

                                if (store.getters['basket/voucher'] === null) {
                                    let organisations = dependant.organisations
                                    console.log(organisations)

                                    let cashbackCount = 0;

                                    for (let x in organisations) {
                                        if (organisations[x] && organisations[x].cashbacks && organisations[x].cashbacks.length > 0) {
                                            this.cashbacks.push({
                                                index: index,
                                                dependant: dependant,
                                                organisation: organisations[x].name,
                                                codes: organisations[x].cashbacks
                                            })

                                            this.cashbackOrganisations.push(organisations[x])

                                            this.code = organisations[x].cashbacks[0].code

                                            cashbackCount++


                                        }
                                    }

                                    if (cashbackCount === 1) {
                                        this.handleSubmitCode()
                                    } else if (cashbackCount > 1) {
                                        this.code = '';
                                        this.dialog = true;
                                    }
                                }



                            });
                        }

                    } else if (event === 0) {
                        let myself = this.myself;

                        let organisations = myself.organisations
                        this.code = ''

                        let cashbackCount = 0;

                        for (let x in organisations) {

                            if (organisations[x] && organisations[x].cashbacks && organisations[x].cashbacks.length > 0) {
                                this.cashbacks.push({
                                    index: index,
                                    dependant: null,
                                    organisation: organisations[x].name,
                                    codes: organisations[x].cashbacks
                                })

                                this.cashbackOrganisations.push(organisations[x])

                                this.code = organisations[x].cashbacks[0].code

                                cashbackCount++

                                //this.dialog = true;
                            }
                        }

                        if (cashbackCount === 1) {
                            this.handleSubmitCode()
                        } else if (cashbackCount > 1) {
                            this.code = '';
                            this.dialog = true;
                        }
                    }
                });



            },
            navigate (routeName) {
                this.$router.push({name: routeName})
            },
            async handleSubmit () {

                this.submitted = true;

                let products = this.basketProducts

                //const isValid0 = await this.$refs.observer.validate();

                let numValid = 0
                let numActivates = 0

                for (let x in products) {
                    let thisValid = await this.$refs.observer[x].validate();
                    if (thisValid) {
                        numValid++
                    }

                    if (products[x].activate) {
                        numActivates++
                    }
                }

                if (numValid === products.length && numActivates === 0) {
                    this.$router.push({name: 'checkout'})
                }
                else if (numValid === products.length && numActivates > 0) {
                    this.numActivates = numActivates
                    this.activatesDialog = true
                }

            },
            decrement (index) {
                this.basketProducts[index].quantity--
            },
            increment (index) {
                this.basketProducts[index].quantity++
            },
            handleSubmitCode () {
                let cashbacks = this.cashbacks;
                this.voucherValid = false

                for (let x in cashbacks) {

                    let cashback = cashbacks[x];
                    let organisation = cashback.organisation;
                    let dependant = cashback.dependant;
                    let codes = cashback.codes;
                    let index = cashback.index;

                    let found = false;
                    let provider = this.$refs.provider;

                    for (let i in codes) {
                        let code = codes[i].code.toLowerCase()

                        if (code === this.code.toLowerCase()) {
                            this.addCashback({code, organisation, dependant, index}).then(() => {
                                console.log(this.basketProducts)
                            })

                            this.code = ''
                            this.dialog = false
                            //found = true
                        }
                    }

                    // if (found === false) {
                    //     provider.applyResult({
                    //         errors: ["code not found"], // array of string errors
                    //         valid: false, // boolean state
                    //         failedRules: {} // should be empty since this is a manual error.
                    //     });
                    // }

                }
            },
            handleSubmitVoucher () {
                store.dispatch('alert/clear');

                let code = this.voucher

                let apiClient = axios.create({
                    baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
                    withCredentials: true,
                });

                apiClient
                    .get('/api/vouchers/' + code)
                    .then(response => {
                        if (response.status === 200) {
                            let voucher = response.data.data
                            this.applyVoucher({voucher}).then(() => {
                                store.dispatch('alert/success', i18n.t('voucher applied'), { root: true });
                            })
                        }
                    })
                    .catch(error => {
                        store.dispatch('alert/error', i18n.t('voucher not found'), { root: true });
                    })


            },
            continueCheckout() {
                this.$router.push({name: 'checkout'})
            }
        },
        watch: {
            personalised (val) {
                if (val === true) {
                    let product = this.personalisedBundle
                    if (product) {
                        return this.addSilent({product}).then(() => {
                            store.dispatch('alert/success', i18n.t('You have switched to a personalised bundle'), { root: true });
                        })
                    }
                }
                if (val === false) {
                    let product = this.nonPersonalisedBundle
                    if (product) {
                        return this.addSilent({product}).then(() => {
                            store.dispatch('alert/success', i18n.t('You have switched to a non-personalised bundle'), { root: true });
                        })
                    }
                }
            }
        },
    }
</script>

<style scoped>
    .clear-button {
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .checkout-button {
        margin-top: 10px;
        margin-right: 0 !important;
    }
    .totals {
        padding: 10px 10px 0 10px;
    }
    .total {
        margin-right: 20px;
    }
    .basket-card {
        border-radius: 15px !important;
        padding: 20px;
        min-height: 300px;
    }
    .basket-card div {
        border-radius: 0 !important;
    }
    .basket-list {
        background-color: transparent;
    }
    .basket-item {
        background-color: var(--v-background-base);
        border-radius: 15px;
        margin-bottom: 15px;
    }
    .basket-item .v-list-item__content > * {
        flex: none;
    }
    .basket-detail p {
        padding: 0 16px;
    }
    /*.basket-card .v-card__actions {*/
    /*    padding-right: 15px;*/
    /*    padding-bottom: 15px;*/
    /*    position: absolute;*/
    /*    bottom: 0;*/
    /*    right: 0;*/
    /*}*/
</style>
